import { Provider, useSelector }   from 'react-redux'
import { LocalizationProvider }    from '@mui/x-date-pickers'
import { AdapterMoment }           from '@mui/x-date-pickers/AdapterMoment'
import Beacon4Store from './store/Beacon4Store'
import App          from './App'

// Inner wrapper: reads role from the OUTER Redux store (state.session.user.role)
// BEFORE the inner Provider is created. The outer useSelector picks up the
// session store; once <Provider store={Beacon4Store}> takes over, any inner
// useSelector calls hit the internal store.
function Beacon4PerformanceInner() {
  const externalRole = useSelector(state => state?.session?.user?.role)

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Provider store={Beacon4Store}>
        <App externalRole={externalRole} />
      </Provider>
    </LocalizationProvider>
  )
}

export default function Beacon4Performance() {
  return <Beacon4PerformanceInner />
}
